<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
const prefixCls = "k-btn-group";
export default {
  name: "k-button-group",
  props: {
    circle: Boolean
  },
  data() {
    return {};
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-circle`]: !!this.circle
        }
      ];
    }
  },
  methods: {},
  mounted() {
    for (let node of this.$el.children) {
      if (node.nodeName.toLowerCase() !== "button") {
        console.warn("按钮组使用不规范，请参考官方文档");
      }
    }
  }
};
</script>
